module.exports = __webpack_public_path__ + "img/gaikaung.e88d7ef0.jpg";